import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

interface ReportData {
    type: 'POSITIVE' | 'NEGATIVE';
    title: string;
    amount: number;
    message: string;
    suggestion: string;
    icon: string;
    colorClass: string;
}

@Component({
    selector: 'app-monthly-report',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatButtonModule, MatCardModule],
    templateUrl: './monthly-report.component.html',
    styleUrls: ['./monthly-report.component.css']
})
export class MonthlyReportComponent implements OnChanges {
    @Input() totalSpent: number = 0;
    @Input() budget: number = 0;
    @Input() catTotals: { [key: string]: number } = {};
    @Input() date: Date = new Date();

    report: ReportData | null = null;
    isVisible = false;

    ngOnChanges() {
        if (this.totalSpent > 0 && this.budget > 0) {
            this.generateInsight();
        } else {
            this.isVisible = false;
        }
    }

    generateInsight() {
        const monthName = this.date.toLocaleString('default', { month: 'long' });
        const diff = this.budget - this.totalSpent;

        if (diff >= 0) {
            // POSITIVE SCENARIO
            this.report = {
                type: 'POSITIVE',
                title: `${monthName} Wins! 🏆`,
                amount: diff,
                message: `You stayed under budget!`,
                suggestion: diff > 1000
                    ? `You saved ₹${diff.toLocaleString()}. Consider moving this to your Savings Goal!`
                    : `Great job hitting your targets. Treat yourself to a small reward!`,
                icon: 'trending_up',
                colorClass: 'positive-card'
            };
        } else {
            // NEGATIVE SCENARIO
            const overage = Math.abs(diff);

            // Find top culprit category
            let topCat = '';
            let maxCatVal = 0;
            Object.entries(this.catTotals).forEach(([cat, val]) => {
                if (val > maxCatVal) {
                    maxCatVal = val;
                    topCat = cat;
                }
            });

            const pct = Math.round((maxCatVal / this.totalSpent) * 100);

            this.report = {
                type: 'NEGATIVE',
                title: 'Budget Alert ⚠️',
                amount: overage,
                message: `Overshot by ₹${overage.toLocaleString()}`,
                suggestion: `${topCat} took ${pct}% of spend. Try setting a specific limit for ${topCat} this month.`,
                icon: 'warning',
                colorClass: 'negative-card'
            };
        }
        this.isVisible = true;
    }
}
